import * as types from '../actions/types'

const initialState = {
    authData: null,
    loading : false,
    error : null
}

const authReducer = (state = initialState , action) => {
    switch(action.type){
        case types.LOGIN_REQUEST : {
            return {
                ...state,
                loading : true
            }
        }
        case types.LOGIN_SUCCESS : {
            return {
                ...state,
                loading:false,
                authData : action.payload
            }
        }
        case types.LOGIN_FAILED : {
           return { ...state,
            loading : false,
            error: action.payload
           }
        }

        case types.LOGOUT : {
            window.localStorage.removeItem('authData')
            return {
                authData: null,
                loading : false,
                error : null
            }
        }
        default:{
           return {
            ...state
           } 
        }
    }

}

export default  authReducer